import type { ActionExecutor } from "../TriggerEngine.interfaces";

import {
  switchScene,
  toggleArea,
  cloneArea,
  hideArea,
  showArea,
  hideWidget,
  showWidget,
  hideElement,
  showElement,
} from "./scene.actions";

import { playMedia, pauseMedia, changeText } from "./media.actions";

import {
  playlistPlay,
  playlistPause,
  playlistNext,
  playlistPrev,
} from "./playlist.actions";

import { micMute, micUnmute } from "./mic.actions";

import { webhook } from "./external.actions";

import {
  enableProtectedMode,
  disableProtectedMode,
  enableSystemAudio,
  disableSystemAudio,
} from "./system.actions";

import {
  sendChatMessage,
  deleteMessage,
  timeoutUser,
  banUser,
} from "./bot.actions";

export const actionRegistry = new Map<string, ActionExecutor>([
  ["switch_scene", switchScene],

  ["toggle_area", toggleArea],

  ["play_media", playMedia],

  ["pause_media", pauseMedia],

  ["change_text", changeText],

  ["playlist_play", playlistPlay],

  ["playlist_pause", playlistPause],

  ["playlist_next", playlistNext],

  ["playlist_prev", playlistPrev],

  ["mic_mute", micMute],

  ["mic_unmute", micUnmute],

  ["webhook", webhook],

  ["clone_area", cloneArea],

  ["hide_area", hideArea],

  ["show_area", showArea],

  ["hide_widget", hideWidget],

  ["show_widget", showWidget],

  ["hide_element", hideElement],

  ["show_element", showElement],

  ["enable_protected_mode", enableProtectedMode],

  ["disable_protected_mode", disableProtectedMode],

  ["enable_system_audio", enableSystemAudio],

  ["disable_system_audio", disableSystemAudio],

  ["send_chat_message", sendChatMessage],

  ["delete_message", deleteMessage],

  ["timeout_user", timeoutUser],

  ["ban_user", banUser],
]);
